import { render, staticRenderFns } from "./EditPromotionBaseSettingsHall.vue?vue&type=template&id=3070f986&"
import script from "./EditPromotionBaseSettingsHall.vue?vue&type=script&lang=js&"
export * from "./EditPromotionBaseSettingsHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports